<script setup lang="ts">
import { iconVariants } from '@/shared/components/iconVariants'

import type { IconSeverity } from '@/shared/components/iconVariants'
import type { Component } from 'vue'

const props = defineProps<{
  icon: Component
  severity?: IconSeverity
}>()
</script>

<template>
  <component
    :is="props.icon"
    :class="iconVariants({ severity: props.severity })"
  />
</template>
